import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormCategoria from './FormCategoria';

import getCategorias from '../../../../graphql/querys/otros/getCategorias.graphql';
import insertCategoria from '../../../../graphql/mutations/otros/insertCategoria.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertCategoria, {
  name: 'insertCategoria',
  options: {
    refetchQueries: [{ query: getCategorias }],
  },
})
class CrearCategoria extends React.Component {
  constructor(props) {
    super(props);

    // console.log("Entre al constructor");

    this.state = {
      categoria: {
        nombre: '',
        descripcion: '',
      },
      step: 0,
      loading: false,
    };

    this.guardarCategoria = this.guardarCategoria.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarCategoria(categoria) {
    this.props
      .insertCategoria({
        variables: {
          categoria,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description: 'Se ha registrado la nueva categoria exitosamente',
        });

        this.props.history.push('/admin/otros/categorias');
      })
      .catch(err => {
        console.log('Error en la creacion de la categoria');
        console.log(err);
        errorService(err, categoria);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Categoria</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Categoria
          </h2>
          <br />
          <div style={estiloContent}>
            <FormCategoria
              className="formularios"
              onSubmit={this.guardarCategoria}
              onAnterior={() =>
                this.props.history.push('/admin/otros/categorias')
              }
              datos={this.state.categoria}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearCategoria);
